<template>
  <div class="grid grid-flow-row grid-cols-2 overflow-auto gap-2 max-w-[400px]">
    <div style="vertical-align: top !important">Revenue</div>
    <div>
      Invoice Total $ - Sales Tax $<br />
      <em
        >Please note this revenue does not include recurring revenue<br />
        from membership billing.</em
      >
    </div>

    <div>Jobs Sold</div>
    <div>Opportunities marked as a Win with > $0 amounts</div>

    <div>Close Rate</div>
    <div>Jobs sold / (Opportunity Wins + Losses)</div>

    <div>Opportunity Avg</div>
    <div>Job Revenue / (Opportunity Wins + Losses)</div>

    <div>Membership Opportunity</div>
    <div>A valid opportunity that begins with a non-member</div>

    <div>Memberships Sold</div>
    <div>Won Opportunities that include a Membership in the Sale</div>

    <div>Membership Win Rate (MWR)</div>
    <div>Opportunities with a Membership Sold / Membership Opportunities</div>

    <div>Opportunity</div>
    <div>Opportunities Won + Opportunities Lost</div>

    <div>Won Opportunity</div>
    <div>A job completed with a signature with > $0 in revenue.</div>

    <div>Job Close Rate</div>
    <div>Opportunities Won / Opportunities</div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
